// extracted by mini-css-extract-plugin
export default {"cls1":"wiVxlFHIGE631dmOrJ9K","cls2":"Ea8ziiG3FHds6gzQ7lCl wiVxlFHIGE631dmOrJ9K"};